// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"5d404393","220":"f0dca834","263":"7827622c","360":"93f5fba0","453":"8cceba42","612":"df1db32e"}[chunkId] + ".chunk.js";
};